import React from "react";
import { Percent, Camera, UserX, MessagesSquare, LineChart, ShieldCheck } from "lucide-react";
import { ContentPage, Section, FeatureCard } from "../../components/ContentPage";

export default function Oferta() {
  return (
    <ContentPage
      testid="page-oferta"
      eyebrow="Oferta współpracy"
      title={<>Zarabiaj więcej. <span className="text-coral">My robimy resztę.</span></>}
      lead="PMPOINT to kompletna obsługa marketingowo-sprzedażowa dla twórczyń 18+. Ty tworzysz treści, my zamieniamy uwagę w realne przychody — na platformach typu OnlyFans, Fansly, Fanvue, MYM i innych."
      seo={{
        title: "Oferta współpracy dla twórczyń 18+ | PMPOINT",
        description: "Kompletna obsługa: marketing, strategia, czatowanie, automatyzacja i rozliczenie procentowe. Współpraca z wizerunkiem lub anonimowa na OnlyFans, Fansly, MYM i innych.",
        canonical: "https://pmpoint.pl/oferta",
      }}
    >
      <Section title="Co dokładnie robimy">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <FeatureCard icon={LineChart} title="Strategia i marketing" text="Budujemy Twoją markę osobistą, prowadzimy kampanie i pozyskujemy ruch, który realnie kupuje." />
          <FeatureCard icon={MessagesSquare} title="Czatowanie i sprzedaż" text="Nasz zespół prowadzi rozmowy z fanami 24/7 i maksymalizuje wartość każdego kontaktu." />
          <FeatureCard icon={Percent} title="Rozliczenie procentowe" text="Zarabiamy tylko wtedy, gdy Ty zarabiasz. Jasne, uczciwe zasady bez ukrytych kosztów." />
          <FeatureCard icon={Camera} title="Model z wizerunkiem" text="Pracujesz twarzą i marką — tworzymy spójny, sprzedażowy przekaz dopasowany do Ciebie." />
          <FeatureCard icon={UserX} title="Model anonimowy" text="Nie pokazujesz twarzy? Budujemy markę i sprzedaż w pełni dyskretnie i anonimowo." />
          <FeatureCard icon={ShieldCheck} title="Bezpieczeństwo" text="Umowa, poufność (NDA), ochrona danych i zgodność z regulaminami platform." />
        </div>
      </Section>

      <Section title="Jak wygląda współpraca">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <FeatureCard title="1. Rozmowa" text="Poznajemy Twoje cele, granice i doświadczenie. Odpowiadamy na wszystkie pytania." />
          <FeatureCard title="2. Strategia" text="Przygotowujemy plan działania dopasowany do Ciebie i Twojego stylu pracy." />
          <FeatureCard title="3. Działanie" text="Tworzymy, wdrażamy i skalujemy kampanie oraz treści na wielu platformach." />
          <FeatureCard title="4. Wyniki" text="Optymalizujemy, rośniemy razem i zwiększamy Twoje przychody — transparentnie." />
        </div>
        <p className="mt-6 text-sm text-white/45">
          Wyniki zależą od profilu, zaangażowania i zakresu współpracy. Nie obiecujemy gwarantowanych kwot — pokazujemy realny plan i transparentne rozliczenia.
        </p>
      </Section>
    </ContentPage>
  );
}
